import React, { useState } from "react";
import "../assets/styles/GlobalQuoteModal.css";
import { requestPublicQuote } from "../api/quotes";

/**
 * 🌐 GlobalQuoteModal.jsx
 * โมดอลขอใบเสนอราคาประกันภัย ใช้ได้กับทุกแพ็กเกจ (Public)
 *
 * Props:
 * - open: boolean        → เปิด/ปิด modal
 * - onClose: function    → ปิด modal
 * - packageInfo: object  → { package_id, company, product_line, category, nameTH, fund }
 */

export default function GlobalQuoteModal({ open, onClose, packageInfo }) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    note: "",
    fund: packageInfo?.fund || "",
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        package_id: packageInfo?.package_id || packageInfo?.id,
        company: packageInfo?.company,
        product_line: packageInfo?.product_line || "motor",
        category: packageInfo?.category || "car",
        name: form.name,
        phone: form.phone,
        note: form.note,
      };

      const res = await requestPublicQuote(payload);
      console.log("✅ Quote sent:", res);
      setSuccess(true);
    } catch (err) {
      console.error("❌ ส่งคำขอใบเสนอราคาล้มเหลว:", err);
      alert("เกิดข้อผิดพลาดในการส่งคำขอใบเสนอราคา กรุณาลองใหม่อีกครั้ง");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="quote-modal-overlay">
      <div className="quote-modal">
        <button className="quote-close" onClick={onClose}>
          ✕
        </button>

        {!success ? (
          <>
            <h2>🧾 ขอใบเสนอราคา</h2>
            <p className="quote-sub">
              {packageInfo.company} — {packageInfo.nameTH}
            </p>

            <form className="quote-form" onSubmit={handleSubmit}>
              <label>
                ชื่อ-นามสกุล
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </label>

              <label>
                เบอร์โทรศัพท์
                <input
                  type="tel"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  required
                />
              </label>

              <label>
                อีเมล
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="(ไม่บังคับ)"
                />
              </label>

              <label>
                ทุนประกัน (บาท)
                <input
                  type="number"
                  name="fund"
                  value={form.fund}
                  onChange={handleChange}
                  placeholder="เช่น 200000"
                />
              </label>

              <label>
                หมายเหตุเพิ่มเติม
                <textarea
                  name="note"
                  value={form.note}
                  onChange={handleChange}
                  rows={3}
                  placeholder="ระบุข้อมูลเพิ่มเติม (ถ้ามี)"
                ></textarea>
              </label>

              <button
                type="submit"
                className="quote-submit"
                disabled={loading}
              >
                {loading ? "⏳ กำลังส่ง..." : "ส่งคำขอใบเสนอราคา"}
              </button>
            </form>
          </>
        ) : (
          <div className="quote-success">
            <h2>✅ ส่งคำขอสำเร็จ</h2>
            <p>เจ้าหน้าที่ของเราจะติดต่อกลับโดยเร็วที่สุด</p>
            <button onClick={onClose} className="quote-submit">
              ปิดหน้าต่าง
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
